import { defineMessages } from 'react-intl';

export default defineMessages({
    RenewalSummaryHeader: {
        id: 'cep.components.sgRenewalQuotePage.Header',
        defaultMessage: 'Your renewal after changes'
    },
    RenewLabel: {
        id: 'cep.components.sgRenewalQuotePage.RenewLabel',
        defaultMessage: 'Renew now'
    },
    BackToMainLabel: {
        id: 'cep.components.sgRenewalQuotePage.BackToMainLabel',
        defaultMessage: 'go back'
    },
});
